"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var A = /** @class */ (function () {
    function A() {
        this.century = function () { return A.century; };
        this.toString = function () { return 'A'; };
    }
    A.tag = 'A';
    A.century = 2000;
    return A;
}());
exports.A = A;
var Minus = /** @class */ (function () {
    function Minus() {
        this.century = function () { return Minus.century; };
        this.toString = function () { return '-'; };
    }
    Minus.tag = 'Minus';
    Minus.century = 1900;
    return Minus;
}());
exports.Minus = Minus;
function parse(century) {
    switch (century) {
        case A.century: return new A();
        case Minus.century: return new Minus();
        default:
            throw new Error("Unsupported century " + century);
    }
}
exports.parse = parse;
function parseId(id) {
    switch (id) {
        case 'A': return new A();
        case '-': return new Minus();
        default:
            throw new Error("Unsupported century id " + id);
    }
}
exports.parseId = parseId;
//# sourceMappingURL=century.js.map